import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

/*const routes = [
  { path: '/:id?', name: 'Home', component: Home },
  { path: '/event/:id?/:adaccount_id/:campaign_id?', name: 'Event', component: () => import('../views/Event.vue') },
  { path: '/events-list/:id?/:adaccount_id/:campaign_id?', name: 'List', component: () => import('../views/List.vue') },
  ,
  { path: '/msg/:id?/:adaccount_id/:campaign_id?', name: 'Msg', component: () => import('../views/Msg.vue') },
  { path: '/form/:id?/:adaccount_id/:campaign_id?', name: 'Form', component: () => import('../views/Form.vue') },
  { path: '/report/:id?/:adaccount_id/:campaign_id?', name: 'Report', component: () => import('../views/Report.vue') }
]*/

const routes = [
  {
    path: '/:type?/:id?',
    name: 'Home',
    component: Home
  },
  {
    path: '/target-event-add/:type?/:id/:adaccount_id?',
    name: 'TargetEventAdd',
    component: () => import('../views/TargetEventAdd.vue')
  },
  {
    path: '/target-event/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'TargetEvent',
    component: () => import('../views/TargetEvent.vue')
  },
  {
    path: '/target-event-browse/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'TargetEventBrowse',
    component: () => import('../views/TargetEventBrowse.vue')
  },
  {
    path: '/target-events-list/:type?/:id?/:adaccount_id?',
    name: 'TargetList',
    component: () => import('../views/TargetList.vue')
  },
  {
    path: '/event-add/:type?/:id/:adaccount_id?',
    name: 'EventAdd',
    component: () => import('../views/EventAdd.vue')
  },
  {
    path: '/event/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'Event',
    component: () => import('../views/Event.vue')
  },
  {
    path: '/event-browse/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'EventBrowse',
    component: () => import('../views/EventBrowse.vue')
  },
  {
    path: '/event-add-tiktok/:type?/:id/:adaccount_id?',
    name: 'EventAddTiktok',
    component: () => import('../views/EventAddTiktok.vue')
  },
  {
    path: '/event-tiktok/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'EventTiktok',
    component: () => import('../views/EventTiktok.vue')
  },
  {
    path: '/event-browse-tiktok/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'EventBrowseTiktok',
    component: () => import('../views/EventBrowseTiktok.vue')
  },
  {
    path: '/events-list/:type?/:id?/:adaccount_id?',
    name: 'List',
    component: () => import('../views/List.vue')
  },
  {
    path: '/customize-events-list/:type?/:id?/:adaccount_id?',
    name: 'CustomizeList',
    component: () => import('../views/CustomizeList.vue')
  },
  {
    path: '/customize-event-add/:type?/:id/:adaccount_id?',
    name: 'CustomizeEventAdd',
    component: () => import('../views/CustomizeEventAdd.vue')
  },
  {
    path: '/customize-event/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'CustomizeEvent',
    component: () => import('../views/CustomizeEvent.vue')
  },
  {
    path: '/customize-event-browse/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'CustomizeEventBrowse',
    component: () => import('../views/CustomizeEventBrowse.vue')
  },
  {
    path: '/strategy-event/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'StrategyEvent',
    component: () => import('../views/StrategyEvent.vue')
  },
  {
    path: '/msg/:id?/:adaccount_id?/:campaign_id?',
    name: 'Msg',
    component: () => import('../views/Msg.vue')
  },
  {
    path: '/form/:id?/:adaccount_id?/:campaign_id?',
    name: 'Form',
    component: () => import('../views/Form.vue')
  },
  {
    path: '/report/:type?/:id?/:adaccount_id?/:campaign_id?',
    name: 'Report',
    component: () => import('../views/Report.vue')
  },
  {
    path: '/msg-admin/:id?/:page_id/:campaign_id?',
    name: 'MsgAdmin',
    component: () => import('../views/MsgAdmin.vue')
  },
  {
    path: '/viedo/:type?/:id?',
    name: 'Video',
    component: () => import('../views/Video.vue')
  },
  {
    path: '/post/:id?',
    name: 'Post',
    component: () => import('../views/Post.vue')
  },
  {
    path: '/demo-advertising-material',
    name: 'DemoAdvertisingMaterial',
    component: () => import('../views/DemoAdvertisingMaterial.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
